import { render, staticRenderFns } from "./build-truck-load-form.html?vue&type=template&id=78c6acdb&scoped=true&"
import script from "./build-truck-load-form.ts?vue&type=script&lang=js&"
export * from "./build-truck-load-form.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c6acdb",
  null
  
)

export default component.exports